<template>
  <div style="width: 100%">
    <v-tabs v-model="tab" class="tab-event">
      <v-tabs-slider color="#3be287"></v-tabs-slider>
      <v-tab v-for="item in tabItems" :key="item">{{ item }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in tabItems" :key="item">
        <v-container v-if="item === 'info'" class="card-container">
          <v-row>
            <v-col
              ><v-row
                ><p class="info-data">Event type :&nbsp;</p>
                <p class="value-data"></p>
                Close Approach</v-row
              >
              <v-row
                ><p class="info-data">Detection date :&nbsp;</p>
                <p class="value-data">
                  {{
                    getDisplayValueFromPath(
                      conjunctionInfoEvent.detectionDate,
                      ['detectionDate'],
                      'AbstractEvent'
                    )
                  }}
                </p></v-row
              ></v-col
            >
            <v-divider vertical></v-divider>
            <v-col
              ><v-row
                ><p class="info-data">Norad ID target:&nbsp;</p>
                <p class="value-data"></p>
                {{
                  getDisplayValueFromPath(
                    conjunctionInfoEvent.eventTargetNoradId,
                    ['eventTargetNoradId'],
                    'AbstractEvent'
                  )
                }}</v-row
              >
              <v-row
                ><p class="info-data">Norad ID chaser :&nbsp;</p>
                <p class="value-data">
                  {{
                    getDisplayValueFromPath(
                      conjunctionInfoEvent.chaserNoradId,
                      ['chaserNoradId'],
                      'AbstractEvent'
                    )
                  }}
                </p></v-row
              ></v-col
            >
            <v-divider vertical></v-divider>
            <v-col
              ><v-row
                ><p class="info-data">Approach date :&nbsp;</p>
                <p class="value-data"></p>
                {{
                  getDisplayValueFromPath(
                    conjunctionInfoEvent.closeApproachDate,
                    ['closeApproachDate'],
                    'AbstractEvent'
                  )
                }}</v-row
              >
              <v-row
                ><p class="info-data">Closest distance :&nbsp;</p>
                <p class="value-data">
                  {{
                    getDisplayValueFromPath(
                      conjunctionInfoEvent.closestApproachDistance,
                      ['closestApproachDistance'],
                      'AbstractEvent'
                    )
                  }}
                  km
                </p></v-row
              ></v-col
            >
          </v-row>
          <v-row>
            <v-col>
              <span class="text-h6">Target TLEs</span>
              <v-textarea
                v-model="getTargetTles"
                readonly
                style="font-family: monospace"
                full-width
                outlined
                rows="3"
                class="mb-n7"
              ></v-textarea>
            </v-col>
            <v-col>
              <span class="text-h6">Chaser TLEs</span>
              <v-textarea
                v-model="getChaserTles"
                readonly
                style="font-family: monospace"
                full-width
                outlined
                rows="3"
                class="mb-n7"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
        <v-container
          v-if="item === 'graph'"
          style="height: 480 px"
          class="card-container"
        >
          <ScreeningCatalogueAnalysisPlotsConjunction
            :satellitesDatas="satellitesDatas"
            :timelineDates="timelineDates"
          /> </v-container></v-tab-item
    ></v-tabs-items>
  </div>
</template>
satellitesDatas: this.satellitesDatas, timelineDates: this.timelineDates,

<script>
import * as Cesium from 'cesium'
import TLEDecoder from '../../components/Toolbox/TLEDecoder'
import ScreeningCatalogueAnalysisPlotsConjunction from './ScreeningCatalogueAnalysisPlotsConjunction.vue'
import defense from '../../mixins/defense'

export default {
  name: 'ScreeningCatalogueAnalysisEventsConjunctionVisualizer',
  props: {
    conjunctionInfoEvent: {
      type: Object
    }
  },
  components: {
    TLEDecoder,
    ScreeningCatalogueAnalysisPlotsConjunction
  },
  mixins: [defense],
  data() {
    return {
      satellitesDatas: [],
      timelineDates: [],
      textDescription:
        'Both space objects (the chaser and the target) are displayed with a line between them corresponding to the distance separating the two objects. The first position points of each object are those retrieved just after the distance between them has dropped under the close approach threshold, and the last points are those just before this distance goes above the threshold again. In the event that a close approach is detected but that there are not enough given data points to get the distance all the way until it overshoots the threshold, both the chaser and the target orbits are propagated over the number of orbits set in the alert.',
      tabItems: ['info', 'graph'],
      tab: null
    }
  },
  watch: {
    conjunctionInfoEvent() {
      this.updatesDatas()
    }
  },
  computed: {
    getTargetTles() {
      return this.conjunctionInfoEvent.targetEventTles.join('\n')
    },
    getChaserTles() {
      return this.conjunctionInfoEvent.chaserEventTles.join('\n')
    }
  },
  mounted() {
    this.updatesDatas()
  },
  methods: {
    async updatesDatas() {
      this.satellitesDatas = []
      this.timelineDates = []
      const startDate = this.conjunctionInfoEvent.conjunctionStartDate

      const endDate = this.conjunctionInfoEvent.conjunctionEndDate
      this.satellitesDatas = await this.getDataTwoSatellites({
        firstName: 'Target',
        secondName: 'Chaser',
        firstColor: Cesium.Color.GREEN,
        secondColor: Cesium.Color.RED,
        firstTles: this.conjunctionInfoEvent.targetEventTles,
        secondTles: this.conjunctionInfoEvent.chaserEventTles,
        startDate: startDate,
        endDate: endDate,
        firstOrbitLine: false,
        secondOrbitLine: false,
        firstPlanes: null,
        secondPlanes: null
      })
      this.timelineDates.push({
        color: 'blue',
        tooltip: 'Start Date',
        date: startDate
      })
      this.timelineDates.push({
        color: 'red',
        tooltip: 'Date of closest approach',
        date: this.conjunctionInfoEvent.closeApproachDate
      })
      this.timelineDates.push({
        color: 'blue',
        tooltip: 'End Date',
        date: endDate
      })
      this.sendDatasForCesium({
        satellitesDatas: this.satellitesDatas,
        timelineDates: this.timelineDates,
        textDescription: this.textDescription
      })
    },
    sendDatasForCesium(item) {
      this.$emit('cesium-visualizer-method', item)
    }
  }
}
</script>
<style scoped>
.info-data {
  font-weight: bold;
  margin-left: 15px;
}
.card-container {
  height: 475px;
  overflow-y: scroll;
  scrollbar-width: none;
}
</style>
